import { useState } from "react";

const payments = [
  {
    id: "00040",
    title: "Payment job",
    client: "Sukhwinder Singh",
    requested: "06/04/2026",
    method: "Cash",
    status: "Requested",
    amountDue: 4.0,
  },
];

const CheckIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#22c55e"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const CalendarIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#9ca3af"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const CashIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#9ca3af"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
    <line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);

const TABS = ["All (1)", "Requested (1)", "Denied"];

const PaymentManagement = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="pro-app-page pro-app-page--muted">
      <div className="custom_container">
        <div
          style={{
            background: "#f3f4f6",
            width: "100%",
            borderRadius: 10,
          }}
        >
          {/* Header */}
          <div
            style={{
              background: " linear-gradient(90deg, #cc4645 0%, #9a1d1c 100%)",
              padding: "28px 20px 36px",
              borderRadius: "10px 10px 28px 28px",
            }}
          >
            <div style={{ marginBottom: 18 }}>
              <h1
                style={{
                  color: "#fff",
                  fontSize: 22,
                  fontWeight: 800,
                  margin: 0,
                  letterSpacing: -0.3,
                }}
              >
                Payment Management
              </h1>
              <p
                style={{
                  color: "rgba(255,255,255,0.75)",
                  fontSize: 13,
                  margin: "4px 0 0",
                }}
              >
                Track and manage client payments
              </p>
            </div>

            {/* Stats Row */}
            <div style={{ display: "flex", gap: 10 }}>
              {[
                { label: "Total Received", value: "$2,240.00" },
                { label: "Pending", value: "$4.00", icon: "🕐" },
              ].map((stat) => (
                <div
                  key={stat.label}
                  style={{
                    background: "#ffeff0",
                    backdropFilter: "blur(8px)",
                    borderRadius: 14,
                    padding: "12px 14px",
                    flex: 1,
                    border: "1px solid rgba(255,255,255,0.25)",
                  }}
                >
                  <div
                    style={{
                      color: "#cc4645",
                      fontSize: 12,
                      fontWeight: 600,
                    }}
                  >
                    {stat.icon && (
                      <span style={{ marginRight: 4 }}>{stat.icon}</span>
                    )}
                    {stat.label}
                  </div>
                  <div
                    style={{
                      color: "#cc4645",
                      fontSize: 17,
                      fontWeight: 800,
                      marginTop: 4,
                    }}
                  >
                    {stat.value}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div style={{ padding: "20px 16px" }}>
            {/* Section title */}
            <h2
              style={{
                fontSize: 13,
                fontWeight: 800,
                letterSpacing: 1.2,
                color: "#333",
                textTransform: "uppercase",
                marginBottom: 14,
              }}
            >
              Payment Requests
            </h2>

            {/* Tabs */}
            <div
              style={{
                display: "flex",
                gap: 8,
                marginBottom: 18,
                overflowX: "auto",
                paddingBottom: 2,
              }}
            >
              {TABS.map((tab, i) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(i)}
                  style={{
                    padding: "7px 16px",
                    borderRadius: 50,
                    border: activeTab === i ? "none" : "1.5px solid #ddd",
                    background: activeTab === i ? "#cc4645" : "#fff",
                    color: activeTab === i ? "#fff" : "#555",
                    fontWeight: 700,
                    fontSize: 13,
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    transition: "all 0.2s",
                  }}
                >
                  {tab}
                </button>
              ))}
            </div>

            {/* Payment Card */}
            {payments.map((p) => (
              <div
                key={p.id}
                style={{
                  background: "#fff",
                  borderRadius: 18,
                  padding: 18,
                  marginBottom: 14,
                  boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                  }}
                >
                  <div>
                    <div style={{ color: "#999", fontSize: 12 }}>
                      Job #{p.id}
                    </div>
                    <div
                      style={{
                        fontWeight: 800,
                        fontSize: 16,
                        color: "#111",
                        marginTop: 2,
                      }}
                    >
                      {p.title}
                    </div>
                    <div style={{ color: "#666", fontSize: 13, marginTop: 2 }}>
                      Client: {p.client}
                    </div>
                    <div style={{ color: "#888", fontSize: 12, marginTop: 6 }}>
                      Requested: {p.requested}
                      <span style={{ marginLeft: 12, color: "#888" }}>
                        💳 {p.method}
                      </span>
                    </div>
                  </div>
                  <span
                    style={{
                      background: "#fff0f0",
                      color: "#cc4645",
                      borderRadius: 10,
                      padding: "4px 12px",
                      fontSize: 12,
                      fontWeight: 700,
                      border: "1.5px solid #fff0f0",
                      whiteSpace: "nowrap",
                    }}
                  >
                    🕐 {p.status}
                  </span>
                </div>

                {/* Amount Due Box */}
                <div
                  style={{
                    background: "#fff5f5",
                    borderRadius: 12,
                    padding: "12px 14px",
                    marginTop: 14,
                  }}
                >
                  <div style={{ color: "#888", fontSize: 12 }}>Amount Due</div>
                  <div
                    style={{
                      fontWeight: 800,
                      fontSize: 22,
                      color: "#111",
                      marginTop: 2,
                    }}
                  >
                    ${p.amountDue.toFixed(2)}
                  </div>
                </div>

                {/* Send Reminder */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 12,
                  }}
                >
                  <button
                    style={{
                      background: "#fff",
                      border: "1.5px solid #ddd",
                      borderRadius: 10,
                      padding: "8px 18px",
                      fontWeight: 700,
                      fontSize: 13,
                      color: "#333",
                      cursor: "pointer",
                    }}
                  >
                    Send Reminder
                  </button>
                </div>
              </div>
            ))}

            {/* Payment History */}
            <h2
              style={{
                fontSize: 15,
                fontWeight: 800,
                color: "#333",
                marginBottom: 14,
                marginTop: 20,
              }}
            >
              Payment History
            </h2>

            <div
              style={{
                background: "#fff",
                borderRadius: "14px",
                padding: "16px 20px",
                width: "100%",
                boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "flex-start",
                gap: "14px",
              }}
            >
              <div
                style={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "50%",
                  background: "#f0fdf4",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <CheckIcon />
              </div>

              <div style={{ flex: 1 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "4px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: "#111827",
                    }}
                  >
                    Deposit
                  </span>
                  <span
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: "#111827",
                    }}
                  >
                    $2
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "6px",
                  }}
                >
                  <span style={{ fontSize: "12.5px", color: "#6b7280" }}>
                    02/04/2026
                  </span>
                  <span
                    style={{
                      fontSize: "12.5px",
                      fontWeight: 500,
                      color: "#22c55e",
                    }}
                  >
                    Completed
                  </span>
                </div>

                <div
                  style={{ display: "flex", alignItems: "center", gap: "14px" }}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      fontSize: "12px",
                      color: "#6b7280",
                    }}
                  >
                    <CalendarIcon /> <b>02/04/2026</b>
                  </span>
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      fontSize: "12px",
                      color: "#6b7280",
                    }}
                  >
                    <CashIcon /> <b>Cash</b>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentManagement;
